// extracted by mini-css-extract-plugin
module.exports = {"tabBody":"campaignsTab_tabBody__3KEi-","emptyMessage":"campaignsTab_emptyMessage__1IddF","campaignCount":"campaignsTab_campaignCount__2DrBv"};